import axios from "axios";
import { apiRoot, auth } from "../../index";
import { startLoading, stopLoading } from "../loader";

export async function getSubscriptionInfos(token) {
  startLoading();

  try {
    const res = await axios.post(
      `${apiRoot}/api/v1/stripe/is-subscription-valid`,
      {},
      {
        headers: {
          Authorization: token,
        },
      }
    );

    stopLoading();

    return res.data;
  } catch (e) {
    stopLoading();
    await auth.signOut();
  }
}

export async function getSubscriptionCheckoutSecret(token) {
  startLoading();

  const res = await axios.get(
    `${apiRoot}/api/v1/stripe/subscription-checkout-client-secret`,
    {
      headers: {
        Authorization: token,
      },
    }
  );

  stopLoading();
  return res.data;
}

export async function getSubscriptionPortalLink(token) {
  startLoading();

  const res = await axios.get(
    `${apiRoot}/api/v1/stripe/subscription-portal-link`,
    {
      headers: {
        Authorization: token,
      },
    }
  );

  stopLoading();

  return res.data;
}
